import React, { useEffect, useState } from 'react'
import { v2_categories, v2_siteLocations } from '../../../actions/v2/masterData';
import { v2_all_user } from '../../../actions/v2/user';
import { useDebouncedValue } from '../../../customHook/useDebouncedValue';

const Filter = ({ onChangeFilter, initialFilter = {} }) => {

    // Kept out of `state` so typing doesn't fire the filter effect on every keystroke.
    const [keyword, setKeyword] = useState(initialFilter.keyword || '');
    const debouncedKeyword = useDebouncedValue(keyword);

    const [state, setState] = useState({
        category: { name: 'category', value: initialFilter.categoryId || '', options: [] },
        assignedUser: { name: 'assignedUser', value: initialFilter.assignedUser || '', options: [] },
        locationId: {
            name: 'locationId', value: initialFilter.locationId || '', options: []
        },
        fromDate: {
            name: 'fromDate', value: initialFilter.fromDate || ''
        },
        toDate: {
            name: 'toDate', value: initialFilter.toDate || ''
        },
        status: {
            name: 'status', value: initialFilter.status || '', options: ['Unscheduled', 'Scheduled', 'In Progress', 'Accepted', 'Rejected', 'Cancelled', 'Re-Inspection']
        }

    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: value
            }
        }));
    };

    const handleClearSearch = () => {
        setKeyword('');
    };


    useEffect(() => {

        v2_categories().then((res) => {
            if (res.status && res.result) {
                setState((prev) => ({
                    ...prev,
                    category: {
                        ...prev.category,
                        options: res.result.map((item) => ({
                            label: item.CATEGORY_NAME,
                            value: item.ID,
                        }))
                    }
                }));
            }
        })

        v2_all_user().then((res) => {
            if (res.status && res.result) {
                setState((prev) => ({
                    ...prev,
                    assignedUser: {
                        ...prev.assignedUser,
                        options: res.result.map((item) => ({
                            label: item.FULL_NAME,
                            value: item.USER_ID,
                        }))
                    }
                }));
            }
        })
        v2_siteLocations().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['locationId']: {
                        ...prev['locationId'],
                        options: res.result.map((item) => {
                            return {
                                value: item.ID,
                                label: item.LOCATION_NAME
                            }
                        }) || []
                    }
                }));
            }
        })

    }, []);


    useEffect(() => {
        const model = {
            categoryId: state.category.value,
            keyword: debouncedKeyword,
            assignedUser: state.assignedUser.value,
            locationId: state.locationId.value,
            status: state.status.value,
            fromDate: state.fromDate.value,
            toDate: state.toDate.value

        }
        onChangeFilter(model)
    }, [state, debouncedKeyword])
    return (
        <div className="filters-card">
            <h5 className="filters-title" style={{ fontSize: 13 }}>
                Filters
            </h5>
            <div className="filter-tab-channels-box inspection-filter filter-top-box">
                <div className="input-box">
                    <div className="search-section-box search-fat-box">
                        <form
                            className="app-search "
                            onSubmit={(e) => e.preventDefault()}
                        >
                            <div className="position-relative">

                                <input
                                    type="text"
                                    className="form-control search-input-with-clear"
                                    placeholder="Search subject or remark..."
                                    value={keyword}
                                    onChange={(e) => setKeyword(e.target.value)}
                                />

                                <span className="bx bx-search-alt" />
                                {keyword && (
                                    <button
                                        type="button"
                                        className="search-clear-btn"
                                        aria-label="Clear search"
                                        title="Clear search"
                                        onClick={handleClearSearch}
                                    >
                                        <i className="bx bx-x" />
                                    </button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
                <div className="input-box">
                    <select className="form-select"
                        onChange={handleChange}
                        value={state.category.value}
                        name={state.category.name}
                    >
                        <option value={''}>All Categories</option>
                        {state.category.options.map((option) => {
                            return (
                                <option value={option.value}>{option.label}</option>
                            )
                        })}
                    </select>
                </div>
                <div className="input-box">
                    <select className="form-select"
                        onChange={handleChange}
                        value={state.locationId.value}
                        name={state.locationId.name}
                    >
                        <option value={''}>All Location</option>
                        {state.locationId.options.map((option) => {
                            return (
                                <option value={option.value}>{option.label}</option>
                            )
                        })}
                    </select>
                </div>
                <div className="input-box">
                    <select className="form-select"
                        onChange={handleChange}
                        value={state.assignedUser.value}
                        name={state.assignedUser.name}
                    >
                        <option value={''}>Assignee / Attendee</option>
                        {state.assignedUser.options.map((option) => {
                            return (
                                <option value={option.value}>{option.label}</option>
                            )
                        })}
                    </select>
                </div>

                <div className="input-box">
                    <select className="form-select"
                        onChange={handleChange}
                        value={state.status.value}
                        name={state.status.name}
                    >
                        <option value={''}>Status</option>
                        {state.status.options.map((option) => {
                            return (
                                <option value={option}>{option}</option>
                            )
                        })}
                    </select>
                </div>

                <div className="input-box">

                    <input
                        className={`form-control `}
                        type="text"
                        onFocus={(e) => (e.target.type = "date")}
                        onBlur={(e) => !e.target.value && (e.target.type = "text")}
                        placeholder="Scheduled Start Date"
                        onChange={handleChange}
                        value={state.fromDate?.value || ""}
                        name={state.fromDate?.name}
                    />

                </div>
                <div className="input-box">

                    <input className={`form-control `}
                        type="text"
                        onFocus={(e) => (e.target.type = "date")}
                        onBlur={(e) => !e.target.value && (e.target.type = "text")}
                        placeholder="Scheduled To Date"
                        onChange={handleChange}
                        value={state.toDate.value}
                        name={state.toDate.name}
                    />
                </div>
            </div>
        </div>
    )
}

export default Filter
